import { createInjectionState, useToggle } from '@vueuse/core'
import { computed } from 'vue'
import constants from '@/generated/constants.js'
import maps from '@/generated/maps.js'

const [useProvideTeamAssetItem, _useTeamAssetItem] = createInjectionState((teamAsset) => {
  const [isRenaming, toggleIsRenaming] = useToggle(false)

  const assetType = computed(() => maps.App_Models_TeamAsset.categoriesTypeMap[teamAsset.value.category])
  const isTypeImage = computed(() => assetType.value === constants.App_Models_TeamAsset.TYPE_IMAGE)
  const isTypeDoc = computed(() => assetType.value === constants.App_Models_TeamAsset.TYPE_DOC)

  return {
    teamAsset,
    isRenaming,
    toggleIsRenaming,

    isTypeImage,
    isTypeDoc,
  }
})

function useTeamAssetItem() {
  const res = _useTeamAssetItem()
  if (!res) {
    throw new Error('useTeamAssetItem must be used within a TeamAssetItemProvider')
  }

  return res
}

export {
  useProvideTeamAssetItem,
  useTeamAssetItem,
}
